import StorageUtils from '@spothero/utils/storage';
export default function getUserLocation() {
    const userLatLng = StorageUtils.get('sh-user-location', 'session');
    return userLatLng ? { user_location: userLatLng } : null;
}
